// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../img/input-checkmark.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input[type="checkbox"] {
    display:none;
}
.checkbox_group {
    display: flex;
    flex-direction: column;
}
.checkbox_unchecked + label::before {
    width: 20px;
    height: 20px;
    border-radius: 5px;
    border: 0.8px solid #cec8c8;
    background-color: #fff;
    display: block;
    content: "";
    float: left;
    margin-right: 5px;
}

.checkbox_unchecked:disabled + label::before {
    width: 20px;
    height: 20px;
    border-radius: 5px;
    border: 0.8px solid #E1E1E1;
    background-color: #fff;
    opacity: 0.5;
    display: block;
    content: "";
    float: left;
    margin-right: 5px;
}

.checkbox_radio_unchecked + label::before {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    border: 2px solid #CDE1EB;
    background-color: #fff;
    display: block;
    content: "";
    float: left;
    margin-right: 15px;
}
.radio_checked+label::before {
    width: 16px;
    height: 16px;
    border: 2px solid #9391A9;
    background-color: #B3B2C3;
    margin-right: 15px;
}
.checkbox_checked+label::before {
    width: 20px;
    height: 20px;
    border: 0.8px solid #9391A9;
    background-color: #B3B2C3;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: 50%;
    background-position: center center;
    background-repeat: no-repeat;
}
.check-group_label > p {
    font-size: 0.8rem;
    color: rgba(0,0,0,0.8);
    font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/Components/SimpleComponents/Checkbox.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;AACA;IACI,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,2BAA2B;IAC3B,sBAAsB;IACtB,cAAc;IACd,WAAW;IACX,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,2BAA2B;IAC3B,sBAAsB;IACtB,YAAY;IACZ,cAAc;IACd,WAAW;IACX,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,sBAAsB;IACtB,cAAc;IACd,WAAW;IACX,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,yBAAyB;IACzB,yDAAsD;IACtD,oBAAoB;IACpB,kCAAkC;IAClC,4BAA4B;AAChC;AACA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;AACpB","sourcesContent":["input[type=\"checkbox\"] {\n    display:none;\n}\n.checkbox_group {\n    display: flex;\n    flex-direction: column;\n}\n.checkbox_unchecked + label::before {\n    width: 20px;\n    height: 20px;\n    border-radius: 5px;\n    border: 0.8px solid #cec8c8;\n    background-color: #fff;\n    display: block;\n    content: \"\";\n    float: left;\n    margin-right: 5px;\n}\n\n.checkbox_unchecked:disabled + label::before {\n    width: 20px;\n    height: 20px;\n    border-radius: 5px;\n    border: 0.8px solid #E1E1E1;\n    background-color: #fff;\n    opacity: 0.5;\n    display: block;\n    content: \"\";\n    float: left;\n    margin-right: 5px;\n}\n\n.checkbox_radio_unchecked + label::before {\n    width: 16px;\n    height: 16px;\n    border-radius: 50%;\n    border: 2px solid #CDE1EB;\n    background-color: #fff;\n    display: block;\n    content: \"\";\n    float: left;\n    margin-right: 15px;\n}\n.radio_checked+label::before {\n    width: 16px;\n    height: 16px;\n    border: 2px solid #9391A9;\n    background-color: #B3B2C3;\n    margin-right: 15px;\n}\n.checkbox_checked+label::before {\n    width: 20px;\n    height: 20px;\n    border: 0.8px solid #9391A9;\n    background-color: #B3B2C3;\n    background-image: url('../../img/input-checkmark.svg');\n    background-size: 50%;\n    background-position: center center;\n    background-repeat: no-repeat;\n}\n.check-group_label > p {\n    font-size: 0.8rem;\n    color: rgba(0,0,0,0.8);\n    font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
